export function CommissionEditQueueIntro({ filteredCount }: { filteredCount: number }) {
  return (
    <div className="mb-6 flex flex-col gap-2 lg:flex-row lg:items-end lg:justify-between">
      <p className="max-w-2xl text-sm text-muted-foreground">
        Suivi des corrections demandées sur les commissions, avec historique des décisions et
        comparaison des valeurs proposées.
      </p>
      <p className="text-[11px] text-subtle">
        {filteredCount} résultat{filteredCount !== 1 ? "s" : ""} affiché
        {filteredCount !== 1 ? "s" : ""}
      </p>
    </div>
  );
}
